<script lang="ts" setup>
import { useDark } from '@vueuse/core'
// Composition API
import nl from "~/assets/locale/nl";
import en from "~/assets/locale/en";

import { usePrimeVue } from 'primevue/config';

const isDark = useDark();
watch(isDark, () => {
  if (isDark.value)
    document.documentElement.classList.add('p-dark')
  else
    document.documentElement.classList.remove('p-dark')
})

const { locale } = useI18n()
const primevue = usePrimeVue();
primevue.config.locale = locale.value == 'en' ? en : nl;
watch(locale, () => {
  primevue.config.locale = locale.value == 'en' ? en : nl;
})


if (isDark.value)
  document.documentElement.classList.add('p-dark')

const { auth } = useSupabaseClient();
const route = useRoute();
const subscription = auth.onAuthStateChange((event, session) => {
  // A hint for tickable.nl to show "Open dashboard" instead of signing up; not a credential
  if (location.hostname.endsWith('tickable.nl'))
    document.cookie = `tk_signed_in=1; domain=tickable.nl; path=/; max-age=${session ? 2592000 : 0}; secure; samesite=lax`
  // Already on a sign-in page: stay, navigating again would wipe the form being filled in. The
  // public share page needs no session at all.
  if (event === 'SIGNED_OUT' && !route.params.invitation_id && !route.path.startsWith('/auth/') && !route.path.startsWith('/share/')) {
    navigateTo('/auth/login');
  } else if (event === 'PASSWORD_RECOVERY') {
    navigateTo('/auth/recover');
  }
})

useSessionGuard();
</script>

<template>
  <NuxtPage />
</template>